export const CrossSvg = () => {
    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.87581 1.08633C9.10418 1.31356 9.10511 1.68291 8.87787 1.91128L5.82225 4.98225L8.91286 8.08838C9.14009 8.31676 9.13917 8.6861 8.91079 8.91334C8.68242 9.14057 8.31307 9.13965 8.08584 8.91127L4.99935 5.80928L1.91286 8.91127C1.68563 9.13965 1.31628 9.14057 1.0879 8.91334C0.859529 8.6861 0.858604 8.31676 1.08584 8.08838L4.17645 4.98225L1.12083 1.91128C0.893592 1.68291 0.894517 1.31356 1.12289 1.08633C1.35127 0.859095 1.72061 0.86002 1.94785 1.0884L4.99935 4.15522L8.05085 1.08839C8.27809 0.860017 8.64743 0.859092 8.87581 1.08633Z" fill="#4A5565" />
        </svg>

    )
}
